(function ($) {
  
  var extLink = $('a').filter(function() { 
    return this.hostname && this.hostname !== location.hostname
  });
  extLink.each(function(){
    $(this).attr('target', '_blank');
  });

  
  $('#site-nav--mobile .link-list .mobile-link span').on('click', function() {
    $(this).parent().parent().toggleClass('open');
  });

  $('#site-nav--mobile .link-list .baby-link span').on('click', function() {
    $(this).parent().parent().toggleClass('open');
  });

})(jQuery)
